// @ constants
const actionTypes = require('constants/actionTypes');

const setPortfolioOnEditionMode = (idPortfolioAccount, name) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_EDIT_MODE_ACCEPT,
    payload: {
       idPortfolioAccount,
       name
    }
});

const setPortfolioOnNextEditMode = (nextPortfolio) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_NEXT_EDIT_MODE_ACCEPT,
    payload: {
        nextPortfolio
    }
})

const setPortfolioOnViewMode = (idPortfolioAccount) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_SET_ON_EDIT_MODE_CANCEL,
    payload: {
        idPortfolioAccount
     }
});

const confirmLeaveEditionToOtherPage = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_OTHER_PAGE_CONFIRMED,
})

const leaveEditionToEdition = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_EDITION_MODE_REQUEST,
})

const leaveEditionToDelete = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_DELETE_MODE_REQUEST,
})

const acceptLeaveEditionToDelete = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_DELETE_MODE_CONFIRMED,
})

const acceptLeaveEditionToEdition = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_TO_EDITION_MODE_CONFIRMED,
})

const cancelLeaveEdition = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_LEAVE_EDITION_MODE_CANCELED,
})

const cancelEdition = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_PORTFOLIO_CANCEL_EDITION,
})

module.exports = {
    setPortfolioOnEditionMode,
    setPortfolioOnNextEditMode,
    setPortfolioOnViewMode,
    confirmLeaveEditionToOtherPage,
    leaveEditionToDelete,
    leaveEditionToEdition,
    acceptLeaveEditionToDelete,
    acceptLeaveEditionToEdition,
    cancelEdition,
    cancelLeaveEdition
}
